import { useState, useEffect } from "react";
import CustomSlider from "./components/CustomSlider/CustomSlider.js";
import "./components/CustomSlider/CustomSlider.css";
import AudioRecorder from "./AudioRecorder";
import "./TextResizer.css";
import { Box, Typography } from "@mui/material";
import useWindowSize from "./components/CustomFontSizeHook/CustomFontSizeHook.js";

const TextResizer = ({
  hideSlider,
  setHideSlider,
  hideArrow,
  setHideArrow,
  audioBlobForAudioPlayer,
  setAudioBlobForAudioPlayer,
  paragraph,
  processedData,
  setProcessedData,
  assessmentId,
  setAssessmentId,
  studentName,
  setStudentName,
  orfResultStatus,
  setOrfResultStatus,
  selectedLaguage,
  setSelectedLaguage,
  saveClicked,
  setSaveClicked,
  isAudioUploading,
  setAudioUploading,
  uploadAudioStatus,
  setUploadAudioStatus,
  setActiveScreen,
}) => {
  const windowSize = useWindowSize();
  const isSmallScreen = windowSize.width < 600;

  const getDefaultFontSize = (isSmallScreen) => (isSmallScreen ? 32 : 50);
  const getSliderConfig = (isSmallScreen) => ({
    min: isSmallScreen ? 24 : 36,
    max: isSmallScreen ? 40 : 64,
    defaultValue: getDefaultFontSize(isSmallScreen),
    marks: isSmallScreen
      ? [{ value: 24, label: "A" }, { value: 32 }, { value: 40, label: "A" }]
      : [{ value: 36, label: "A" }, { value: 50 }, { value: 64, label: "A" }],
  });

  const [fontSize, setFontSize] = useState(getDefaultFontSize(isSmallScreen));
  const [sliderConfig, setSliderConfig] = useState(
    getSliderConfig(isSmallScreen)
  );

  useEffect(() => {
    setFontSize(getDefaultFontSize(isSmallScreen));
    setSliderConfig(getSliderConfig(isSmallScreen));
  }, [isSmallScreen]);

  return (
    <Box>
      <Box className="textresizer-container">
        <Typography className="para-text" style={{ fontSize: `${fontSize}px` }}>
          {paragraph}
        </Typography>
      </Box>
      <Box className="text-size-slider-container">
        <Box>
          {!hideSlider && (
            <Box className="slider">
              <CustomSlider
                min={sliderConfig.min}
                max={sliderConfig.max}
                defaultValue={sliderConfig.defaultValue}
                fontSize={fontSize}
                step={1}
                setSliderValue={setFontSize}
                marks={sliderConfig.marks}
              />
            </Box>
          )}
          <Box>
            <AudioRecorder
              hideSlider={hideSlider}
              setHideSlider={setHideSlider}
              hideArrow={hideArrow}
              setHideArrow={setHideArrow}
              audioBlobForAudioPlayer={audioBlobForAudioPlayer}
              setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
              processedData={processedData}
              setProcessedData={setProcessedData}
              assessmentId={assessmentId}
              setAssessmentId={setAssessmentId}
              studentName={studentName}
              setStudentName={setStudentName}
              orfResultStatus={orfResultStatus}
              setOrfResultStatus={setOrfResultStatus}
              selectedLaguage={selectedLaguage}
              setSelectedLaguage={setSelectedLaguage}
              saveClicked={saveClicked}
              setSaveClicked={setSaveClicked}
              isAudioUploading={isAudioUploading}
              setAudioUploading={setAudioUploading}
              uploadAudioStatus={uploadAudioStatus}
              setUploadAudioStatus={setUploadAudioStatus}
              setActiveScreen={setActiveScreen}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TextResizer;
